import React from "react";

/**
 *
 * @param name
 * @param value
 * @param required
 * @returns {JSX.Element}
 * @constructor
 */
export default function Percentage ({ name, value, required }) {
    return (
        <>
            <input
                className="form-control"
                type="number"
                min="0"
                max="100"
                step="0.00000001"
                name={name}
                placeholder="%"
                defaultValue={value}
                required={required}
            />
        </>
    );
}